var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLabel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 3.25A1.75 1.75 0 0 0 1.25 5v6c0 .966.784 1.75 1.75 1.75h7.5a2.75 2.75 0 0 0 2.2-1.1l1.725-2.3c.6-.8.6-1.9 0-2.7L12.7 4.35a2.75 2.75 0 0 0-2.2-1.1H3zM2.75 5A.25.25 0 0 1 3 4.75h7.5c.393 0 .764.185 1 .5l1.725 2.3c.2.267.2.633 0 .9l-1.725 2.3a1.25 1.25 0 0 1-1 .5H3a.25.25 0 0 1-.25-.25V5z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLabel);
export default ForwardRef;